import { withBrowserContext } from '../../../utils/localizationContext/withBrowserContext';
import { dateTimeFormat as dateTimeFormatBase } from '../../../utils/formatters/dateTime';

export { DATETIME_ELEMENT_STYLES } from '../../../utils/formatters/dateTime';
export const dateTimeFormat = withBrowserContext(dateTimeFormatBase);
